import { render, staticRenderFns } from "./rc1.vue?vue&type=template&id=3ac858d6&"
import script from "./rc1.vue?vue&type=script&lang=js&"
export * from "./rc1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports